import React from 'react';
import { TextField } from '@material-ui/core';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import StyledTextField, { Error } from './styles';

const CustomTextField = ({ name, type, label, errors, touched, ...rest }) => {
	return (
		<StyledTextField>
			<Field
				type={type}
				name={name}
				as={TextField}
				label={label}
				variant="outlined"
				errors={errors}
				{...rest}
			/>
			{errors && errors[name] && touched[name] && <Error>{errors[name]}</Error>}
		</StyledTextField>
	);
};

export default CustomTextField;

CustomTextField.defaultProps = {
	type: 'text'
};

CustomTextField.propTypes = {
	name: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired
};
